import { registerLocale } from "react-datepicker";
import { fi } from "date-fns/locale";

// This is a workaround for TypeScript compatibility with react-datepicker
// The type definition doesn't match exactly what react-datepicker expects
interface SimplifiedLocale {
  localize: {
    month: (n: number) => string;
    day: (n: number) => string;
  };
  formatLong: {
    date: () => string;
    time: () => string;
    dateTime: () => string;
  };
  // Add required missing properties with minimal implementations
  code: string;
  formatDistance: () => string;
  formatRelative: () => string;
  match: {
    ordinalNumber: () => { value: string; unit: string };
    era: () => { value: string; unit: string };
    quarter: () => { value: string; unit: string };
    month: () => { value: string; unit: string };
    day: () => { value: string; unit: string };
    dayPeriod: () => { value: string; unit: string };
  };
}

// Create a custom Finnish locale for the DatePicker
// with proper translations for month and day names
const customFinnishLocale = {
  ...fi,
  localize: {
    ...fi.localize,
    month: (monthIndex: number): string => {
      const months = [
        "Tammikuu",
        "Helmikuu",
        "Maaliskuu",
        "Huhtikuu",
        "Toukokuu",
        "Kesäkuu",
        "Heinäkuu",
        "Elokuu",
        "Syyskuu",
        "Lokakuu",
        "Marraskuu",
        "Joulukuu",
      ];
      return months[monthIndex];
    },
    day: (dayIndex: number): string => {
      const days = ["su", "ma", "ti", "ke", "to", "pe", "la"];
      return days[dayIndex];
    },
  },
  formatLong: {
    ...fi.formatLong,
    // Enforce Finnish date format (DD.MM.YYYY)
    date: () => "dd.MM.yyyy",
  },
};

// Register locales for react-datepicker
// Both "fi" and "fi_FI" to ensure compatibility with different imports
export const setupLocales = (): void => {
  try {
    registerLocale("fi", customFinnishLocale);
    registerLocale("fi_FI", customFinnishLocale);
  } catch (error) {
    console.error("Error registering Finnish locale for DatePicker:", error);
  }
};

// Run setup on import
setupLocales();
